<template>
	<vxe-modal :loading="loading" v-model="modal" width="600" height="auto" @show="show" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="供应商" >
					<el-input readonly v-model="form.supplier"></el-input>
				</el-form-item>
				<el-form-item required label="内容" >
					<el-input v-model="form.content" type="textarea" :rows="10"></el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="success" content="复制" @click="copy"></vxe-button>
			<vxe-button status="primary" content="发送" @click="send"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			row: {
				default: () => {
					return []
				}
			},
			detail: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				title: '砍价话术',
				form: {
					content: '',
					deliverytype: '',
					suppliername: null
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {

			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modalShow() {
				//console.log(this.row, this.detail)
				this.title = '砍价话术【' + this.row.billCode + '】'
				this.form.supplier = this.row.supplierName
				this.content = this.componentStore.getcontent(this.row, this.detail, 'bargain')
				// console.log(this.content)
				this.form.content = this.content.text
				this.modal = true
			},

			send() {
				if (!this.form.content) {
					this.$message.error('请输入内容')
					return
				}
				this.$api.wlnpurchase.reportgoods({
					data: this.detail,
					content: this.form.content,
					supplierid: this.row.supplierID,
					type: 'send',
					action: 'bargain'
				}).then(() => {
					this.$message.success('发送成功')
					this.componentStore.customreload()
				})
			},
			copy() {
				if (!this.form.content) {
					this.$message.error('请输入内容')
					return
				}
				this.$copyText(this.form.content).then(() => {
					this.$api.wlnpurchase.reportgoods({
						data: this.detail,
						supplierid: this.row.supplierID,
						type: 'copy'
					}).then(() => {
						this.$message.success('复制成功')
						this.componentStore.customreload()
					})
				}, () => {
					this.$message.success('复制失败')
				})
			}


		},
		components: {

		}
	}
</script>